import React, { useEffect, useState } from "react";
// import PageHeader from "./components/PagesHeaderComponent/PageHeader";
import { Calendar, momentLocalizer } from 'react-big-calendar';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import moment from 'moment';
import { Modal, PageHeader, Pagination } from 'antd';
import { faArrowLeft, faArrowRightLong, faUsers } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Card from 'react-bootstrap/Card';
import { Tabs } from "antd";
import { NavLink, useNavigate } from "react-router-dom/dist";
import PageHeaderWithRoutes from "../components/PagesHeaderComponent/PageHeaderWithRoute";
import CompanyMeetingIcon from "../../assets/images/icons/company_meeting_icon.png"
import EVotingIcon from "../../assets/images/icons/evoting_icon.png"
import DirectorshipIcon from "../../assets/images/icons/directorship_icon.png"
import AdvisoryServiceIcon from "../../assets/images/icons/advisory_service_icon.png"
import { Col, Container, Row } from "react-bootstrap";
import InnerHeading from "../components/InnerHeading/InnerHeading";
import CoreHttpHandler from "../../http/services/CoreHttpHandler";
import CustomTextLimit from "../../assets/global-components/TextLimit";

const localizer = momentLocalizer(moment);
const { TabPane } = Tabs;

const EVoting = () => {

    const navigate = useNavigate();

    const [activeTab, setActiveTab] = useState("Upcoming");
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [totalRecords, setTotalRecords] = useState(0);
    const [currentPage, setCurrentPage] = useState(0);
    const [modalShow, setModalShow] = useState(false);
    const [videoUrl, setVideoUrl] = useState("");
    const getAllEVoting = (limit, page) => {
        setIsLoading(true)
        CoreHttpHandler.request(

            "e_services",
            // activeTab === "Upcoming" ?
            "fetchEVoting",
            // : "fetchArchiveWebinarsnEvents",
            {
                type: "eVoting",
                status: "true",
                "limit": limit || 6,
                "page": page || 1
            },
            (res) => {
                setData(res?.data?.data?.shareholderss?.data)
                setTotalRecords(res?.data?.data?.shareholderss.totalRecords)
                setCurrentPage(res?.data?.data?.shareholderss.page)
                setIsLoading(false)
                // ToastAlertSuccess("Item removed Successfully");
            },
            (err) => {
                // ToastAlertError(
                // 	err?.response?.data?.message
                // 		? err?.response.data.message
                // 		: "something went wrong"
                // );
            }
        );
    };
    const tabs = [
        { name: "Upcoming" },
        { name: "Archived" }
    ];
    useEffect(() => {
        getAllEVoting();
    }, [])

    // const data = [
    //     {
    //         title: "AGM Meeting 2024 ",
    //         date: "27th Feb 09:30",
    //         participants: "10 Participants"
    //     },
    //     {
    //         title: "AGM Meeting 2024 ",
    //         date: "27th Feb 09:30",
    //         participants: "8 Participants"
    //     },
    //     {
    //         title: "AGM Meeting 2024 ",
    //         date: "27th Feb 09:30",
    //         participants: "8 Participants"

    //     }

    // ]

    let headerData = [{
        name: "Company Meeting & Announcements",
        route: "/E-service/CompanyMeeting&Announcements",
        imgSrc: CompanyMeetingIcon
    }, {
        name: "E-Voting",
        route: "/E-service/E-Voting",
        imgSrc: EVotingIcon
    }
    //     , {
    //     name: "Directorship",
    //     route: "/E-service/Directorship",
    //     imgSrc: DirectorshipIcon
    // }
    //     , {
    //     name: "Advisory Services",
    //     route: "/E-service/AdvisoryServices",
    //     imgSrc: AdvisoryServiceIcon
    // }
    ]

    return (
        <>




            <PageHeaderWithRoutes tabs={headerData} heading="E-Services" desc="Discover a range of e-services such as the AGM/EOGM Calendar, e-voting options, directorship resources, and advisory services. These tools are crafted to streamline governance tasks and empower informed decision-making for shareholders and issuers alike." />



            <div className="content_wrap">


                <div className="e_service">
                    <div className='container'>
                        <div className="cards_wrap">

                            <Container>
                                <Row>
                                    <InnerHeading heading="E-Voting" text="Make yourself heard! Participate in secure electronic voting for AGM/EOGM resolutions and governance decisions." />

                                    {/* <div className="tabs">
                                        <h5
                                            className={`tab-button ${activeTab === 'Upcoming' ? 'active' : ''}`}
                                            onClick={() => setActiveTab('Upcoming')}
                                        >
                                            Upcoming
                                        </h5>
                                        <h5
                                            className={`tab-button ${activeTab === 'Archived' ? 'active' : ''}`}
                                            onClick={() => setActiveTab('Archived')}
                                        >
                                            Archived
                                        </h5>
                                    </div> */}
                                    {activeTab === 'Upcoming' && data?.map((e) => {
                                        return <>
                                            <Col xl={6} xxl={4} lg={6} md={6} sx={12}>
                                                <Card className="cards" style={{ minHeight: "285px", width: "100%", display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
                                                    {/* <h4>{e.title}</h4>
                                                    <h6>{e?.description}</h6> */}
                                                    <CustomTextLimit oneLineMax limit={50} title text={e.title} />
                                                    <CustomTextLimit oneLineMax text={e.description} />
                                                    <img src={e.image} height="200px" loading="lazy" width="100%"  />

                                                    <h6 style={{ marginTop: "10px" }}><span className="bold">Date: </span>{moment(e?.date).format("DD-MM-YYYY")}</h6>
                                                    <div className="card-content" style={{ marginTop: "5px" }}>
                                                        {/* <h6><FontAwesomeIcon color="#16b2b0" style={{ paddingRight: "10px" }} icon={faUsers} />{e.participants}</h6> */}
                                                        <button onClick={() => window.open(e?.url?.startsWith('http') ? e.url : `https://${e.url}`, '_blank')} disabled={!e?.url} className="rounded_btn" variant="primary">Link</button>
                                                    </div>
                                                </Card>
                                            </Col>
                                        </>
                                    })}
                                    {/* {activeTab === 'Archived' && data.map((e) => {
                                        return <>
                                            <Col lg={4} md={6}>
                                                <Card className="cards">
                                                    <h4>{e.title}</h4>
                                                    <h6><span className="bold">Date / Time: </span>{e.date}</h6>
                                                    <div className="card-content">
                                                        <h6><FontAwesomeIcon color="#16b2b0" style={{ paddingRight: "10px" }} icon={faUsers} />{e.participants}</h6>
                                                        <button className="rounded_btn greenBg" variant="primary">Done</button>
                                                    </div>
                                                </Card>
                                            </Col>
                                        </>
                                    })} */}
                                </Row>
                            </Container>
                            <Pagination
                                total={totalRecords}
                                current={currentPage}
                                pageSize={6}
                                hideOnSinglePage
                                onChange={(e) => {
                                    getAllEVoting(6, e)
                                }} />
                        </div>






                    </div>




                </div>
            </div >


        </>
    );
};

export default EVoting;
